module.exports = __webpack_public_path__ + "blog_digital_factory_blogdesign_griddesign_gif.gif?79bb9ae17d351db3be7b79e48da2fdb5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/digital _factory/blog_digital_factory_blogdesign_griddesign_gif.gif
// module id = 43
// module chunks = 0